import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
import { LiItem } from "../../common/LiItem";
export var SWFProcessing = function SWFProcessing() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "UQwnVh",
    defaultMessage: [{
      "type": 0,
      "value": "If you need to make changes to your order or to the shipping information after you have already created your labels using Ship with Faire, the best option is to cancel the initial shipping label and create a new one."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gUUgvI",
    defaultMessage: [{
      "type": 0,
      "value": "To cancel the label:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Ig/mCO",
    defaultMessage: [{
      "type": 0,
      "value": "Go to the "
    }, {
      "children": [{
        "type": 0,
        "value": "Shipping info"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " section of your "
    }, {
      "children": [{
        "type": 0,
        "value": "order details page"
      }],
      "type": 8,
      "value": "OrderLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      OrderLinkFormatting: function OrderLinkFormatting(chunks) {
        return _OrderLinkFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xWq8Sw",
    defaultMessage: [{
      "type": 0,
      "value": "Select "
    }, {
      "children": [{
        "type": 0,
        "value": "Cancel"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xlrvao",
    defaultMessage: [{
      "type": 0,
      "value": "Create and print new labels through "
    }, {
      "children": [{
        "type": 0,
        "value": "Ship with Faire"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". To avoid mistakes, we suggest checking quantities and shipping details before creating your label."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "i0uRyq",
    defaultMessage: [{
      "type": 0,
      "value": "We also recommend letting your retailer know about the changes to shipping details through "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " to avoid confusion."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};